import { render, staticRenderFns } from "./popNew.vue?vue&type=template&id=5706a753&"
import script from "./popNew.vue?vue&type=script&lang=ts&"
export * from "./popNew.vue?vue&type=script&lang=ts&"
import style0 from "./popNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports